<template>
  <div class="quickview">
        <b-modal id="qv-modal" title="Quickview" size="lg" centered hide-footer @hidden="resetModal"><!--@ok="modalSubmit"-->
			<form ref="form" @submit.stop.prevent="handleSubmit">
				<b-container fluid>
					<b-row class="quickview mb-1">
						<b-col  cols="2" lg="1" md="1" sm="2" class="px-0">
						  <b-list-group>
							<b-list-group-item class="p-0" v-for="item in filterImages(modaldata.gallery_images)" :key="item" @click="modaldata.image = item,isActivethum=item" v-bind:class="{ active: (isActivethum==item)  }"><b-img :src="item.replace('_rg','_th')" fluid></b-img></b-list-group-item>
						  </b-list-group>
						</b-col>
						<b-col cols="10" lg="6" md="6" sm="10">
							<b-img :src="modaldata.image" fluid></b-img>
						</b-col>
						<b-col lg="5" md="5" sm="12">
							<div class="qv-title"><b-link :href="'/product/'+modaldata.product_id" class="qv-title">{{modaldata.title}}</b-link></div>
							<p>{{modaldata.short_description}}</p>
							<span v-if="modaldata.special_price>0 && modaldata.special_price!=null">
							<h1 class="qv-price">{{$root.currency()+$root.tofixed(modaldata.special_price * modaldata_qty, 2)}} <small class="peritem" v-if="modaldata_qty > 1">({{$root.currency()+$root.tofixed(modaldata.special_price, 2)}} per item)</small></h1>
							<p class="my-1">M.R.P.:<del>{{$root.currency()+$root.tofixed(modaldata.price, 2)}}</del></p>
							<p class="mt-1 mb-3">You Save: {{$root.currency()+$root.tofixed(modaldata.price - modaldata.special_price, 2)}} ({{$root.currency()+$root.tofixed((modaldata.price - modaldata.special_price)*100/modaldata.price, 0)}}% off)</p>
							</span>
							<span v-else>
								 <h1 class="qv-price"><small style="font-size:28px;">MRP:</small> {{$root.currency()+$root.tofixed(modaldata.price, 2)}}</h1>
							</span>
							
							<b-row class="mb-3">
								<b-col cols="1" lg="1" md="1" sm="1" class="pt-1 ">Qty </b-col>
								<b-col cols="3" lg="3" md="3" sm="4" class="ml-1"> <b-form-select v-model="modaldata_qty" :options="qty_options"></b-form-select></b-col>
								
								<b-col class="d-md-none" cols="7" lg="12" md="12" sm="7" v-if="$root.customer_info.role==3">
									<b-button pill type="button" class="mr-3" variant="warning">Commission </b-button><span class="commFont">{{modaldata.commission}}%</span>
								</b-col>
							</b-row>
							<b-row class="mb-3 d-none d-md-block" v-if="$root.customer_info.role==3">
								<b-col>
									<b-button pill type="button" class="mr-3" variant="warning">Commission </b-button><span class="commFont">{{modaldata.commission}}%</span>
								</b-col>
								
							</b-row>
							  <b-row class="mb-3">
								<b-col>
								  <!--<b-link class="btn-solid btn2" @click="$root.updateCart(modaldata, modaldata_qty); $bvModal.hide('qv-modal')">Add To Cart</b-link> -->
								  <addtocart-button :productData="modaldata" :pagequickview="true" :cartQty="modaldata_qty" ></addtocart-button>
									
								  <b-link class="ml-3" v-if="$root.customer_info.access_key!=''"><b-img src="../assets/favourite.svg" @click="$root.addtofavourite(modaldata);" style="width:40px;" v-b-tooltip.hover title="Wishlist" placement="bottom"></b-img></b-link>								  
								  <b-link class="ml-3" v-else><b-img src="../assets/favourite.svg" @click="$root.addtofavouriteNotlogin();" style="width:40px;" v-b-tooltip.hover title="Wishlist" placement="bottom"></b-img></b-link>
								  
								  <!--<b-link class="ml-3" v-if="$root.customer_info.role==3" href="/agent/my-shop">
								  <b-icon class="addtoshopNow" icon="shop-window" aria-hidden="true" v-b-tooltip.hover title="Add to Shop" placement="bottom"></b-icon>
								  </b-link> -->
								  <addtoshop-button :productData="modaldata"  iamin="quickview" v-if="$root.customer_info.role==3" ></addtoshop-button>
								  
								</b-col>
								</b-row>
						</b-col>
					</b-row>
				</b-container>
			</form>
		</b-modal>
    </div>
</template>

<script>
import AddtocartButton from "@/components/addtocartButton.vue";
import AddtoshopButton from "@/components/addtoshopButton.vue";
export default {
  name: 'Quickview',
  props: {
    modaldata: {
      price: 0,
      special_price: 0
    },
    modaldataqty: Number,
  },
  components: {
  "addtocart-button": AddtocartButton,
  "addtoshop-button": AddtoshopButton,
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  data() {
    return{
      modaldata_qty: 1,
        qty_options: [
            { value: 1, text: '1' },
            { value: 2, text: '2' },
            { value: 3, text: '3' },
            { value: 4, text: '4' },
            { value: 5, text: '5' },
            { value: 6, text: '6' }
        ],
		isActivethum:'',
    }
  },
  methods:{
    filterImages: function (items) {
			return items.filter(function (item) {
				return item  != ''
			})
		},
    resetModal(){
      this.modaldata_qty = 1;
    },
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.addtoshopNow{
	color: rgb(254 100 111);
    font-size: 30px;
}
.commFont{
font-size:24px;
position: absolute;
}

</style>
